module.exports = __webpack_public_path__ + "static/img/8.29ded91.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/zh/8.png
// module id = pvIY
// module chunks = 0